import { render, staticRenderFns } from "./BrowserCompatibilityComponent.vue?vue&type=template&id=7fb27335&scoped=true&"
import script from "./BrowserCompatibilityComponent.vue?vue&type=script&lang=js&"
export * from "./BrowserCompatibilityComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb27335",
  null
  
)

export default component.exports